import { useContext } from "react";
import {
  UserInputContext,
  type UserInputContextType,
} from "../contexts/UserInputContext";

export function useUserInputContext(): UserInputContextType {
  const context = useContext(UserInputContext);
  if (context === undefined) {
    throw new Error(
      "useUserInputContext must be used within a UserInputProvider",
    );
  }
  return context;
}
